import { getAccessToken } from "context/AuthContext";
import { trackPromise } from "react-promise-tracker";
import User from "context/User";
import { fetchWithTimeout, handleResponse } from "./BaseAPI";

// the API may answer 200 with an error code in the body
async function handleApiResponse(response) {
  const result = await handleResponse(response);
  if (result && result.cod && !String(result.cod).startsWith("2")) {
    return Promise.reject({ code: Number(result.cod), message: result.message });
  }
  return result;
}

const API_U_URL = process.env.REACT_APP_U_API_URL;

async function requestHeaders() {
  const accessToken = await getAccessToken(User.VERITAS);
  const user = User.getUserInfo();

  const requestHeaders = new Headers();
  requestHeaders.append('Accept', 'application/json');
  requestHeaders.append('Content-Type', 'application/json');
  if (accessToken) {
    requestHeaders.append("jwtToken", `${accessToken}`);
    requestHeaders.append("email", `${user.email}`);
  }
  return requestHeaders;
}

// Get API settings (list of API keys)
export async function getApiSettings() {
  const url = `${API_U_URL}/apikey/list`;
  const response = await trackPromise(fetchWithTimeout(url, {
    headers: await requestHeaders()
  }));
  return await handleApiResponse(response);
}

// Create a new API key with the given name
export async function insertApiSetting(apiName) {
  const url = `${API_U_URL}/apikey/create/${apiName}`;
  const response = await trackPromise(fetchWithTimeout(url, {
    headers: await requestHeaders()
  }));
  return await handleApiResponse(response);
}

// Delete an API key
export async function deleteApiSetting(apiKey) {
  const url = `${API_U_URL}/apikey/delete/${apiKey}`;
  const response = await trackPromise(fetchWithTimeout(url, {
    method: "DELETE",
    headers: await requestHeaders()
  }));
  return await handleApiResponse(response);
}

// Get chart report for a specific period and API name (if needed)
export async function getChartReport(period, apiName) {
  const url = `${API_U_URL}/user/chart?period=${period}&apiname=${encodeURIComponent(
    apiName
  )}`;
  const response = await trackPromise(fetchWithTimeout(url, {
    headers: await requestHeaders()
  }));
  return await response.json();
}

export async function getUserOverview() {
  const url = `${API_U_URL}/user/overview`;
  const response = await trackPromise(fetchWithTimeout(url, {
    headers: await requestHeaders()
  }));
  return await response.json();
}

export async function freeSubscription() {
  const url = `${API_U_URL}/user/free_subscription`;
  const response = await trackPromise(fetchWithTimeout(url, {
    headers: await requestHeaders()
  }));
  return await response.json();
}

// Verify URL using the endpoint described in the documentation
export async function verifyUrl(urlToVerify, apiKey) {
  const url = `${API_U_URL}/url/scan`;
  const response = await trackPromise(fetchWithTimeout(url, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "accept": "application/json",
      "apiKey": apiKey,
    },
    body: JSON.stringify({ 
      urls: [urlToVerify], 
      // html_content: true,
      // web_page_info: true,
      // origin: "chatgpt",
      whois: true,
      rescan: false,
      technical_analysis: true 
    }),
  }));
  return await handleResponse(response);
}


